/* eslint-disable import/prefer-default-export */
/**
 * Purchase Selectors
 * Memoized selectors for accessing purchase state data
 */

/**
 * Select entire purchase state as plain JavaScript object
 *
 * @param {Object} state - Redux state
 * @returns {Object} Purchase data as plain object
 */
export const selectPurchase = (state) => {
  return state.purchase?.toJS() || {};
};

/**
 * Select purchase token from purchase state
 *
 * @param {Object} state - Redux state
 * @returns {string} Purchase token
 */
export const selectPurchaseToken = (state) => {
  return state.purchase?.get('token') || '';
};

/**
 * Select passenger ancillaries by passenger ID and segment
 * Returns ancillaries array for a specific passenger and trip segment
 *
 * @param {number|string} passengerId - ID of the passenger
 * @param {string} segment - Segment: 'outgoing' or 'incoming'
 * @returns {Function} Selector function
 */
export const selectPassengerAncillaries = (passengerId, segment = 'outgoing') => {
  return (state) => {
    const passengers = state.purchase?.get('passengers');

    if (!passengers || passengers.size === 0) {
      return [];
    }

    let passengerAncillaries = [];
    passengers.forEach((passenger) => {
      if (passenger.get('id') === passengerId) {
        const key = `${segment}Ancillaries`;
        passengerAncillaries = passenger.get(key)?.toJS() || [];
      }
    });

    return passengerAncillaries;
  };
};
